import React from 'react'
import styled from 'styled-components/macro'
import PropTypes from 'prop-types'

const ButtonCont = styled.button`
  color: #ffffff;
  font-size: 24px;
  line-height: 28px;
  text-align: center;
  border-radius: 4px;
  background-color: rgb(255, 255, 255);
  border: 1px solid rgb(166, 184, 220);
  font-family: Roboto;
  color: rgb(2, 48, 159);
  transition: box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  margin: 0 auto;
  margin-top: 30px;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14),
    0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  width: 100%;
  outline: 0;
  padding: ${props =>
    (props.size === 'small' && '2px 15px') ||
    (props.size === 'medium' && '6px 20px') ||
    (props.size === 'large' && '16px 30px')};

  &:hover {
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14),
      0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  }
  &:focus {
    background-color: rgb(255, 255, 255);
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14),
      0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  }
  &:active {
    background: rgb(176, 197, 240);
    box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14),
      0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  }

  &:last-child {
    margin-right: 0;
  }

  :disabled {
    background: gray;
  }
`

function LightButton({ size, children, onClick, ...props }) {
  return (
    <ButtonCont
      size={size}
      {...props}
      onClick={event => {
        onClick(event)
      }}
    >
      {children}
    </ButtonCont>
  )
}

LightButton.propTypes = {
  size: PropTypes.string,
  children: PropTypes.any,
  onClick: PropTypes.func
}

export default LightButton
